import { useNavigate, useParams } from '@solidjs/router'
import { useSetups } from '@state'
import { type ParentProps, Show, createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { Container, Grid } from 'styled-system/jsx'
import Header from './Header'
import { Menu } from './Menu'
import { useSingle } from './state'

export default function RouteContainer(props: ParentProps) {
	const { setSetupId, setupResource } = useService(useSingle)()
	const { deleteSetupResource } = useService(useSetups)()
	const params = useParams()
	const navigate = useNavigate()

	createEffect(() => {
		setSetupId(params.id)
	})

	createEffect(() => {
		if (deleteSetupResource.state === 'ready') {
			navigate('/')
		}
	})

	return (
		<Show when={setupResource()}>
			<Container
				width="100%"
				px={0}
			>
				<Grid gap={4}>
					<Header setup={setupResource()!} />
					<Grid
						gridTemplateColumns={{
							base: '130px 1fr',
							mdDown: '1fr',
						}}
						alignItems="start"
					>
						<Menu />
						<Grid gap={4}>{props.children}</Grid>
					</Grid>
				</Grid>
			</Container>
		</Show>
	)
}
